import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { CONTACT, content } from "../../data/content";

export const Services = ({ t, lang }) => (
  <section id="trattamenti" className="bg-[#EFECE6] py-24 sm:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>{t.services.eyebrow}</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-normal tracking-tight text-[#1E2721] sm:text-4xl lg:text-5xl">
          {t.services.title}
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[#4A554D]">{t.services.sub}</p>
      </Reveal>

      <div className="mt-14 border-t border-[#4D6354]/15">
        {content.services.map((s, i) => {
          const loc = s[lang];
          return (
            <motion.a
              key={s.id}
              href={`mailto:${CONTACT.email}?subject=${encodeURIComponent(loc.title)}`}
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="service-row group relative block overflow-hidden border-b border-[#4D6354]/15"
            >
              <div className="row-fill absolute inset-0 bg-[#4D6354]" aria-hidden="true" />
              <div className="relative grid items-center gap-2 px-2 py-7 sm:grid-cols-[3.5rem_1fr_auto] sm:gap-6 sm:px-4 sm:py-8">
                <span className="row-meta font-display text-lg italic text-[#C49A5A] transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span>
                  <span className="row-title block font-display text-xl text-[#1E2721] transition-colors duration-300 sm:text-2xl">
                    {loc.title}
                  </span>
                  <span className="row-desc mt-1.5 block max-w-2xl text-sm leading-relaxed text-[#4A554D] transition-colors duration-300">
                    {loc.desc}
                  </span>
                </span>
                <span className="flex items-center gap-4">
                  <span className="row-meta inline-flex items-center gap-1.5 rounded-full border border-[#4D6354]/20 px-3 py-1 text-xs font-semibold text-[#556B5C] transition-colors duration-300">
                    <Clock size={12} />
                    {s.dur}
                  </span>
                  <ArrowUpRight size={20} className="row-arrow text-[#4D6354]" />
                </span>
              </div>
            </motion.a>
          );
        })}
      </div>
    </div>
  </section>
);
